<template>
  <div>
    <el-card v-if="['SALES_STATS','SALES_MANAGER_STATS','COMPANY_STATS'].includes(activeTab)"
      style="margin-bottom: 25px;border: none;box-shadow: none"
      :class="isShow ? 'show_card' : 'show_card header-border'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow">
        <span style="font-weight: bold;font-size: 14px;color: #636569">金额信息说明展示</span>
        <i class="el-icon-arrow-up" v-show="isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开执行流程介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠执行流程介绍">展开</i>
      </div>
      <el-descriptions v-show="isShow" style="margin-bottom: 0;font-size: 13px!important;" border :column="3">
        <el-descriptions-item label="各项金额说明">
          <table class="tableCss">
            <tr>
              <th>已开票金额</th>
              <td>项目在xx-yy时间内开具了发票的金额</td>
            </tr>
            <tr>
              <th>到款金额</th>
              <td>项目开具了发票，且发票在xx-yy时间内到款金额，无论该发票开票时间为何时</td>
            </tr>
            <tr>
              <th>应收账款</th>
              <td>项目开具了发票，但是发票没到款金额，时间2025.1.1-yy</td>
            </tr>
            <tr>
              <th>已收样未开票金额</th>
              <td>管理系统已收样，商务系统审核了合同，未开票/已开票未通过审核金额；管理系统已收样+商务系统审核了合同总金额-项目开票金额</td>
            </tr>
            <tr>
              <th>总审批未到款申请原始数据/分析结果/返样项目总金额</th>
              <td>管理系统已释放原始数据/纯分析释放分析结果的项目总金额-项目开票到款金额</td>
            </tr>
            <tr>
              <th>合同金额</th>
              <td>预付款合同金额+正式合同金额</td>
            </tr>
            <tr>
              <th>预付款合同金额</th>
              <td>属于预付款项目类型的合同总金额</td>
            </tr>
            <tr>
              <th>尾款金额</th>
              <td>合同开具了发票，但是未开完，剩余未开票的金额累加</td>
            </tr>
          </table>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
      </div>
      <export-components :apiFunction="exportInformation" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-if="statsInfo.role.includes(role)" v-for="(statsInfo,statsIndex) in data" :key="statsIndex"
        :label="statsInfo.label" :name="statsInfo.name"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="activeName" v-if="activeTab === 'SALES_WEEK_STATS'">
      <el-tab-pane v-for="(amountName,index) in amountList" :key="index" :label="amountName.label"
        :name="amountName.value"></el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)" :key="activeTab"
      v-if="activeTab !== 'SALES_WEEK_STATS'" @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }"
      :isPagination="true" ref="wMyTable" :page="page" @pageChange="handlePagePagination"
      :isShowRowSelection="true"
      :table-col-check="{ isShow: true, name: activeTab + 'InformationStatistics2' }">
      <div slot="material" slot-scope="{text,record}">
        <a class="el-icon-search" @click="showMaterialInfos(record)">查看详情</a>
      </div>
      <template slot="otherCon">
        <div style="display: flex; align-items: center">
        </div>
      </template>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <show-sales-material v-if="showMaterial" :select-detail="materialInfos" :show-dialog="showMaterial"
      @submit="close"></show-sales-material>
    <ranking :columns="list" :items="amountData[activeName]" :start-date="startDate" :end-date="endDate" v-if="activeTab === 'SALES_WEEK_STATS'"></ranking>
  </div>
</template>

<script>

import _ from "lodash";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import { exportStats, informationStats} from "@/api/dilivery/customer/person";
import {informationStatistics} from "@/utils/data/tableCol/customer/informationStatistics";
import ExportComponents from "@/components/ExportComponents.vue";
import { getDataInLocalStorage, saveDataToLocalStorage } from "@/utils/localStorage";
import {companyInformationStatistics} from "@/utils/data/tableCol/customer/companyInformationStatistics";
import {materialInformationStatistics} from "@/utils/data/tableCol/customer/materialInformationStatistics";
import {salesMaterialStatistics} from "@/utils/data/tableCol/customer/salesMaterialStatistics";
import ShowSalesMaterial from "@/components/customer/ShowSalesMaterial.vue";
import Ranking from "@/components/customer/Ranking.vue";


export default {
  name: "InformationStatistics",
  components: {ShowSalesMaterial, ExportComponents, PictureLoading,Ranking},
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '销售信息统计', name: 'SALES_STATS', role: ['ADMIN','MANAGER','SALES_MANAGER','SALES','FINANCE'], showBadge: false },
        { label: '销售团队统计', name: 'SALES_MANAGER_STATS', role: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'FINANCE'], showBadge: false },
        { label: '公司信息统计', name: 'COMPANY_STATS', role: ['ADMIN','MANAGER','FINANCE'], showBadge: false },
        { label: '物料信息统计', name: 'MATERIAL_IN_OUT_STATS', showBadge: false, role: ['ADMIN','MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','TECH','FINANCE'] },
        { label: '销售物料信息统计', name: 'SALES_MATERIAL_STATS', showBadge: false, role: ['ADMIN','MANAGER','SALES_MANAGER','SALES','SALES_ASSI','SALES_ASSI_MANAGER','TECH','FINANCE'] },
        { label: '销售金额排名', name: 'SALES_WEEK_STATS', showBadge: false, role: ['ADMIN', 'MANAGER','FINANCE'] },
      ],
      sendData: {
        SALES_STATS: { "salesManagerStatsFlag": false },
        SALES_MANAGER_STATS: { "salesManagerStatsFlag": true },
        COMPANY_STATS: {},
        MATERIAL_IN_OUT_STATS: {},
        SALES_MATERIAL_STATS: {},
        SALES_WEEK_STATS: {},
      },
      amountData: {},
      startDate: '',
      endDate: '',
      role: '',
      isShow: true,
      showMaterial: false,
      materialInfos: '',
      amountList: [
        { label: '回款金额', value: 'paymentAmount', list: [{ key: 'amount', boolean: true, name: '回款金额' }, { key: 'salesName', boolean: false, name: '销售名称' }] },
        { label: '签单金额', value: 'signAmount', list: [{ key: 'amount', boolean: true, name: '签单金额' }, { key: 'salesName', boolean: false, name: '销售名称' }] },
        { label: '预付款金额', value: 'prepaymentsAmount', list: [{ key: 'amount', boolean: true, name: '预付款金额' }, { key: 'salesName', boolean: false, name: '销售名称' }] },
        { label: '团队回款金额', value: 'teamPaymentAmount', list: [{ key: 'amount', boolean: true, name: '团队回款金额' }, { key: 'salesName', boolean: false, name: '团队名称' }] },
        { label: '销售大订单', value: 'salesLargeOrders', list: [{ key: 'amount', boolean: true, name: '销售大订单' }, { key: 'salesName', boolean: false, name: '销售名称' }, { key: 'contractNo', boolean: false, name: '合同编号' }] },
      ],
      activeName: 'paymentAmount',
      option: [{ label: '创建时间', value: 'createTime' }],
      activeTab: '',
      loading: true,
    }
  },
  computed: {
    list() {
      if (this.activeName) {
        return this.amountList.find(item => item.value === this.activeName).list
      }
      return []
    },
    columns() {
      if (this.activeTab === 'SALES_STATS') {
        return JSON.parse(JSON.stringify(informationStatistics([] || {}))).filter(item => !item.roles || item.roles.includes('sales'))
      } else if (this.activeTab === 'SALES_MANAGER_STATS') {
        return JSON.parse(JSON.stringify(informationStatistics([] || {}))).filter(item => !item.roles || item.roles.includes('salesManager'))
      } else if (this.activeTab === 'COMPANY_STATS') {
        return JSON.parse(JSON.stringify(companyInformationStatistics([] || {})))
      } else if (this.activeTab === 'MATERIAL_IN_OUT_STATS') {
        return JSON.parse(JSON.stringify(materialInformationStatistics([] || {})))
      } else {
        return JSON.parse(JSON.stringify(salesMaterialStatistics([] || {})))
      }
    },
  },
  mounted() {
    const now = new Date();
    const previousDay = new Date(now);
    previousDay.setDate(now.getDate() - 1);
    previousDay.setHours(23, 59, 59, 0);
    const sendData = {
      title: '创建时间',
      key: 'createTime',
      value: '2025-01-01 00:00:00,' + this.formatDate(previousDay)
    }
    this.getSearchData(sendData, 'first')
  },
  beforeDestroy() {
    saveDataToLocalStorage('isShowInformation', !!this.isShow)
  },
  created() {
    this.role = getDataInLocalStorage('role')
    this.activeTab = this.data.find(item => item.role.includes(this.role)).name
    this.isShow = getDataInLocalStorage('isShowInformation') === 'true'
  },
  methods: {
    showMaterialInfos(row) {
      this.materialInfos = row
      this.showMaterial = true
    },
    close() {
      this.materialInfos = ''
      this.showMaterial = false
    },
    changeShow() {
      this.isShow = !this.isShow
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getSearchData(sendData, key) {
      if (sendData) {
        let data = { ...sendData }
        if (key === 'first' && this.activeTab === 'SALES_WEEK_STATS') {
          const now = new Date();
          const monday = new Date(now);
          const dayOfWeek = now.getDay();
          const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
          monday.setDate(now.getDate() + diffToMonday);
          monday.setHours(0, 0, 0, 0);
          const todayEnd = new Date(now);
          todayEnd.setHours(23, 59, 59, 0);
          const formatDate = (date) => {
            const pad = n => n.toString().padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
          };
          data.value = `${formatDate(monday)},${formatDate(todayEnd)}`
        }
        this.startDate = data.value.split(',')[0]
        this.endDate = data.value.split(',')[1]
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(data).length) {
          this.searchConditionTag.push(data)
        }
        if (this.$refs.wMyTable && this.$refs.wMyTable.searchConditionTag) {
          this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        }
        this.getData('search')
      }
    },
    exportInformation(data) {
      return exportStats({ statsType: this.activeTab }, data)
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getData(searchFlag) {
      let name = this.activeTab
      if (name === 'SALES_MANAGER_STATS') {
        name = 'SALES_STATS'
      }
      this.loading = true
      if (searchFlag) {
        this.page.currentNum = 1;
        this.page.pageSize = 10;
      }
      let sendData = { ...this.sendData[this.activeTab] }
      sendData = this.getSearch(sendData)
      informationStats(name, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          if (this.activeTab === 'SALES_WEEK_STATS') {
            this.amountData = res.data || {}
          } else {
            const searchCondition = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
            let filteredData = res.data
            if (searchCondition.length) {
              filteredData = filteredData.filter(item => {
                return searchCondition.every(condition => {
                  return String(item[condition.key]).indexOf(String(condition.value)) !== -1;
                });
              });
            }
            const mappedData = filteredData.map((item, index) => ({ id: index + 1, ...item }))
            this.tableData = mappedData.slice((this.page.currentNum - 1) * this.page.pageSize, this.page.currentNum * this.page.pageSize);
            this.page.total = parseInt(filteredData.length);
          }
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        if (this.option.map(item => item.value).includes(item.key)) {
          sendData["timeScope"] = {
            "max": item.value.split(',')[1],
            "min": item.value.split(',')[0]
          }
        }
      })
      return sendData
    },
    changeTab() {
      this.$nextTick(() => {
        if (this.activeTab !== 'SALES_WEEK_STATS') {
          this.tableData = []
          this.selectable = []
          this.searchConditionTag = []
          this.sortConditionTag = []
          this.page = { pageSize: 10, currentNum: 1, total: null }
          if (this.$refs.wMyTable) {
            this.$refs.wMyTable.selectedRowKeys = []
            this.$refs.wMyTable.searchConditionTag = []
          }
        }
        this.getData()
      });
    },
  }
}
</script>

<style scoped>
</style>
